import CartProductVariationItem from "@app/react/components/CartProductVariationItem/CartProductVariationItem.jsx";
import Price from "@app/react/components/Price/Price.jsx";
import React from 'react';
import './styles.scss';

/**
 * Variante in sola lettura di Cart: stesse righe prodotto e stesso totale,
 * senza modifica delle quantita, rimozione righe e azioni di checkout.
 *
 * Non passando onChange/onDeleteButtonClick a CartProductVariationItem la
 * riga rende la quantita come valore statico. I dati arrivano dalla prop e
 * non c'e stato locale: nessuna chiamata API.
 *
 * @see Cart
 */
export default function CartReadonly({label = '', data}) {
  const cart = data;
  const total = cart?.total_price;
  const subtotal = cart?.subtotal_price;
  const adjustments = cart?.adjustments ?? [];
  const hasAdjustments = adjustments.length > 0;

  return <div className="cart-wrapper cart-wrapper--readonly">
    <div className="cart-products-wrapper">
      {label && <h2>{label}</h2>}
      <div className="cart-product-variations">
        {(!cart?.items || cart.items.length === 0) ? (
          <div className="cart-empty-message text-center p-4">
            {Drupal.tt('Nessun prodotto')}
          </div>
        ) : (
          cart.items.map(cartItem => (
            <CartProductVariationItem
              key={cartItem.id}
              productVariation={cartItem.product_variation}
              quantity={cartItem.quantity}
            />
          ))
        )}
      </div>
    </div>
    {total && (
      <div className="cart-total">
        {hasAdjustments && subtotal && (
          <div className='subtotal'>
            <span className='label'>{Drupal.tt('Subtotale')}</span>
            <span className='price'><Price value={subtotal}/></span>
          </div>
        )}
        {adjustments.map((adj, i) => (
          <div key={i} className='adjustment'>
            <span className='label'>{adj.label}</span>
            <span className='price'><Price value={adj.amount}/></span>
          </div>
        ))}
        <div className='total'>
          <span className='label'>{Drupal.tt('Totale')}</span>
          <span className='price'><Price value={total}/></span>
        </div>
      </div>
    )}
  </div>
}
